
// import { motion } from "framer-motion";
// import {
//   AiOutlinePlus,
//   AiOutlineDownload,
//   AiOutlineLineChart,
//   AiOutlineWarning,
// } from "react-icons/ai";

// const steps = [
//   {
//     id: "add-application",
//     number: 1,
//     title: "Ingest Data",
//     desc: "Begin by defining your service in the Netraa Configuration. Provide your application name and its required details.",
//     icon: AiOutlinePlus,
//     color: "blue",
//   },
//   {
//     id: "install-agent",
//     number: 2,
//     title: "Visualize Data",
//     desc: "Deploy the lightweight Netraa OneAgent. It automatically detects running processes and injects instrumentation.",
//     icon: AiOutlineDownload,
//     color: "purple",
//   },
//   {
//     id: "view-traces",
//     number: 3,
//     title: "Setup Notification",
//     desc: "Navigate to the Trace tab. You should see live incoming traces visualizing request latency across services.",
//     icon: AiOutlineLineChart,
//     color: "green",
//   },
//   {
//     id: "analyze-bottleneck",
//     number: 4,
//     title: "Our APPS",
//     desc: "Netraa automatically highlights slow database queries or external API calls. Click on any red span to see the root cause.",
//     icon: AiOutlineWarning,
//     color: "orange",
//   },
// ];

// const colorMap = {
//   blue: {
//     icon: "text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20",
//     dot: "bg-blue-500",
//   },
//   purple: {
//     icon: "text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/20",
//     dot: "bg-purple-500",
//   },
//   green: {
//     icon: "text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20",
//     dot: "bg-green-500",
//   },
//   orange: {
//     icon: "text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20",
//     dot: "bg-orange-500",
//   },
// };

// export function renderQuickStart() {
//   return (
//     <div className="mx-auto px-4 sm:px-6 lg:px-8 py-10 transition-opacity duration-300">

//       {/* HEADER */}
//       <div className="mb-14 border-b border-gray-200 dark:border-white/10 pb-10">
//         <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">
//           <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">
//             Quick Start
//           </span>{" "}
//           <span className="text-gray-900 dark:text-white">
//             with Netraa APM
//           </span>
//         </h1>

//         <p className="mt-4 text-gray-600 dark:text-gray-400 text-lg">
//           Follow this guided path to instrument your first application and identify bottlenecks.
//         </p>
//       </div>

//       {/* TIMELINE */}
//       <div className="relative space-y-14">

//         {/* LINE */}
//         <div className="absolute left-6 md:left-7 top-0 bottom-0 w-px bg-gray-200 dark:bg-white/10" />

//         {steps.map((step, i) => {
//           const Icon = step.icon;
//           const colors = colorMap[step.color];

//           return (
//             <motion.div
//               key={step.id}
//               initial={{ opacity: 0, y: 25 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ duration: 0.45, delay: i * 0.08 }}
//               className="relative pl-16 md:pl-20"
//             >

//               {/* DOT */}
//               <div className="absolute left-6 md:left-7 top-6 -translate-x-1/2">
//                 <div
//                   className={`w-7 h-7 rounded-full ${colors.dot}
//                               flex items-center justify-center
//                               text-white text-xs font-bold
//                               ring-4 ring-white dark:ring-[#0F1115]`}
//                 >
//                   {step.number}
//                 </div>
//               </div>

//               {/* CARD */}
//               <div
//                 className="group relative rounded-2xl border border-gray-200 dark:border-white/10
//                            bg-white dark:bg-[#0F1115]
//                            p-6 md:p-8
//                            transition-all duration-300 ease-out

//                            hover:-translate-y-1
//                            hover:shadow-lg hover:shadow-gray-200/40

//                            dark:hover:bg-[#14161B]
//                            dark:hover:shadow-black/60
//                            dark:hover:border-white/20"
//               >

//                 {/* subtle glow overlay */}
//                 <div className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300
//                                 bg-gradient-to-b from-white/5 to-transparent dark:from-white/5 dark:to-transparent" />

//                 <div className="flex gap-5 relative">

//                   {/* ICON */}
//                   <div
//                     className={`w-12 h-12 rounded-xl flex items-center justify-center
//                                 ${colors.icon}
//                                 transition-transform duration-300 group-hover:scale-105`}
//                   >
//                     <Icon size={24} />
//                   </div>

//                   {/* CONTENT */}
//                   <div>
//                     <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
//                       {step.title}
//                     </h3>

//                     <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
//                       {step.desc}
//                     </p>
//                   </div>

//                 </div>
//               </div>

//             </motion.div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  AiOutlinePlus,
  AiOutlineDownload,
  AiOutlineLineChart,
  AiOutlineWarning,
} from "react-icons/ai";

const steps = [
  {
    id: "add-application",
    number: 1,
    title: "Ingest Data",
    desc: "Monitor your host/service and other comnponents by installing our agents.",
    icon: AiOutlinePlus,
    color: "blue",
    route: "/agentsetup",
  },
  {
    id: "install-agent",
    number: 2,
    title: "Visualize Data",
    desc: "To visualize your data visit our Apps page.",
    icon: AiOutlineDownload,
    color: "purple",
    route: "/agentsetup",
  },
  {
    id: "view-traces",
    number: 3,
    title: "Setup Notification",
    desc: "Getting notification regarding the incident becomes more easy. Click on this tile to know the alert integration.",
    icon: AiOutlineLineChart,
    color: "green",
    route: "/agentsetup",
  },
  {
    id: "analyze-bottleneck",
    number: 4,
    title: "Our Apps",
    desc: "Netraa automatically highlights slow database queries or external API calls. Click on any red span to see the root cause.",
    icon: AiOutlineWarning,
    color: "orange",
    route: "/apps",
  },
];

const colorMap = {
  blue: {
    icon: "text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20",
    dot: "bg-blue-500",
  },
  purple: {
    icon: "text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/20",
    dot: "bg-purple-500",
  },
  green: {
    icon: "text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20",
    dot: "bg-green-500",
  },
  orange: {
    icon: "text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20",
    dot: "bg-orange-500",
  },
};

function StepCard({ step, i }) {
  const Icon = step.icon;
  const colors = colorMap[step.color];
  const navigate = useNavigate();

  return (
    <motion.button
      type="button"
      onClick={() => navigate(step.route)}
      initial={{ opacity: 0, y: 25 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: i * 0.08 }}
      className="relative pl-16 md:pl-20 w-full text-left cursor-pointer"
    >
      {/* DOT */}
      <div className="absolute left-6 md:left-7 top-6 -translate-x-1/2">
        <div
          className={`w-7 h-7 rounded-full ${colors.dot}
                      flex items-center justify-center
                      text-white text-xs font-bold
                      ring-4 ring-white dark:ring-[#0F1115]`}
        >
          {step.number}
        </div>
      </div>

      {/* CARD */}
      <div
        className="group relative rounded-2xl border border-gray-200 dark:border-white/10
                   bg-white dark:bg-[#0F1115]
                   p-6 md:p-8
                   transition-all duration-300 ease-out
                   hover:-translate-y-1
                   hover:shadow-lg hover:shadow-gray-200/40
                   dark:hover:bg-[#14161B]
                   dark:hover:shadow-black/60
                   dark:hover:border-white/20"
      >
        {/* subtle glow overlay */}
        <div className="pointer-events-none absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-300
                        bg-gradient-to-b from-white/5 to-transparent dark:from-white/5 dark:to-transparent" />

        <div className="flex gap-5 relative">
          {/* ICON */}
          <div
            className={`w-12 h-12 rounded-xl flex items-center justify-center
                        ${colors.icon}
                        transition-transform duration-300 group-hover:scale-105`}
          >
            <Icon size={24} />
          </div>

          {/* CONTENT */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              {step.title}
            </h3>

            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
              {step.desc}
            </p>
          </div>
        </div>
      </div>
    </motion.button>
  );
}

export function renderQuickStart() {
  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-10 transition-opacity duration-300">
      {/* HEADER */}
      <div className="mb-14 border-b border-gray-200 dark:border-white/10 pb-10">
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">
          <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">
            Quick Start
          </span>{" "}
          <span className="text-gray-900 dark:text-white">with Netraa APM</span>
        </h1>

        <p className="mt-4 text-gray-600 dark:text-gray-400 text-lg">
          Follow this guided path to instrument your first application and identify bottlenecks.
        </p>
      </div>

      {/* TIMELINE */}
      <div className="relative space-y-14">
        {/* LINE */}
        <div className="absolute left-6 md:left-7 top-0 bottom-0 w-px bg-gray-200 dark:bg-white/10" />

        {steps.map((step, i) => (
          <StepCard key={step.id} step={step} i={i} />
        ))}
      </div>
    </div>
  );
}